module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"education":"Education","noEducationRecords":"No Education Records"}}')
  delete Component.options._Ctor
}
